import React, {Component} from "react";
import {connect} from "react-redux";
import {type_popup} from "../../vars/rd";
import ThemeFilter from "../components/popup/theme.filter";
import ChannelDetail from "../components/popup/channel.detail";
import MentDetail from "../components/popup/ment.detail";
import History from "../components/popup/history";
import Business from "../components/popup/business";
import {$} from "../../index";


class Popup extends Component {
    mounted = false;

    componentDidMount() {
        this.mounted = true;
        this.componentLoadComplete.bind(this);
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    // noinspection JSDeprecatedSymbols
    componentWillReceiveProps(nextProps) {
        if(nextProps.popup.display !== this.popup.display) {
            if(!nextProps.popup.display) {
                const popup = $(".popup.mobile-mypage-popup");
                if(popup.length) {
                    popup.addClass("is-closing");
                    setTimeout(function () {
                        popup.removeClass("active is-closing");
                    }, 500);
                }
            }
        }
    }

    componentLoadComplete(cmps) {
        if(this.mounted) {
            $(".popup.mobile-mypage-popup").addClass("active");
        }
    }

    get dispatch() {
        return this.props.hasOwnProperty('dispatch') ? this.props.dispatch : () => {};
    }

    get popup() {
        return this.props.hasOwnProperty('popup') ? this.props.popup : {};
    }

    /**
     * 노출여부
     * @returns {boolean}
     */
    get display() {
        try {
            return this.popup.display;
        } catch (e) {}
        return false;
    }

    /**
     * 팝업 코드
     * @returns {string}
     */
    get code() {
        try {
            return this.popup.code;
        } catch (e) {}
        return '';
    }

    /**
     * 팝업 데이터
     * @returns {*}
     */
    get data() {
        try {
            return this.popup.data;
        } catch (e) {}
        return null;
    }

    /**
     *
     * @returns {Function|null}
     */
    get callback() {
        try {
            return this.popup.callback;
        } catch (e) {}
        return null;
    }

    /**
     * 팝업 컨텐츠
     * @returns {JSX.Element|null}
     */
    contents() {
        switch (this.code) {
            case type_popup.theme_filter:
                return <ThemeFilter
                    data={this.data}
                    callback={this.callback}
                    callbackLoaded={cmp => this.componentLoadComplete(cmp)}  />;
            case type_popup.ment:
                return <MentDetail
                    data={this.data}
                    callback={this.callback}
                    callbackLoaded={cmp => this.componentLoadComplete(cmp)} />;
            case type_popup.channel:
                return <ChannelDetail
                    data={this.data}
                    callback={this.callback}
                    callbackLoaded={cmp => this.componentLoadComplete(cmp)} />;
            case type_popup.history:
                return <History
                    data={this.data}
                    callback={this.callback}
                    callbackLoaded={cmp => this.componentLoadComplete(cmp)} />;
            case type_popup.business:
                return <Business
                    data={this.data}
                    is_popup={true}
                    callback={this.callback}
                    callbackLoaded={cmp => this.componentLoadComplete(cmp)} />;
            default:
                return null;
        }
    }

    /**
     * 팝업 렌더링
     * @returns {JSX.Element}
     */
    render() {
        return (
            <div className="popup mobile-mypage-popup">
                {this.contents()}
                <div className={"popup-bg"}></div>
            </div>
        )
    }
}

const popupStateToProps = (state) => ({
    popup: state.popup,
});

export default connect(popupStateToProps)(Popup);


// WEBPACK FOOTER //
// ./src/pages/include/popup.jsx